module.exports = __webpack_public_path__ + "static/media/embed-graf.bc9ff6a1.png";